export enum LoggerLevelType {
  INFO = 'INFO',
  WARNING = 'WARNING',
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
}

function levelLoggerOrdinalValue(loggerLevel: LoggerLevelType) {
  switch (loggerLevel) {
    case LoggerLevelType.INFO:
      return 0;
    case LoggerLevelType.WARNING:
      return 1;
    case LoggerLevelType.SUCCESS:
      return 2;
    case LoggerLevelType.ERROR:
      return 3;
    default:
      return 0;
  }
}

export function levelLoggerCompare(
  level1: LoggerLevelType,
  level2: LoggerLevelType
) {
  return levelLoggerOrdinalValue(level1) >= levelLoggerOrdinalValue(level2);
}
